import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import moment from "moment";
import { TrailerAsset } from "src/app/types/onPropertyData";
import { LocalizableComponent } from "../../../components/localizable/localizable.component";

@Component({
    selector: 'trailer',
    templateUrl: './trailer.component.html',
    styleUrls: ['./trailer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class TrailerComponent extends LocalizableComponent implements OnInit {
  @Input() trailer: TrailerAsset;
  @Input() isSelected: boolean = false;
  formattedDueDate: string = '';
  serviceLevelTranslate = { "EAM": "Early AM", "1DA": "Next Day Air", "2DA": "Second Day Air", "3DS": "Three Day Select", "GRD": "Ground" };

  constructor(private router: Router) {
    super();
  }

  ngOnInit(): void {
    this.formattedDueDate = this.formatDateWithoutOffset(this.trailer.dueDate);
  }

  formatDateWithoutOffset(date: string | Date): string {
    return date && moment.utc(date).isValid() ? moment.utc(date).format('MM/DD') : '';
  }

  openRequestInNewTab() {
    const url = this.router.serializeUrl(this.router.createUrlTree(['/'], { queryParams: {requestId: this.trailer.requestId} }));
    window.open(url, '_blank');
  }
}
